import { render } from "./IconSchematic.vue?vue&type=template&id=6549fff1&ts=true"
import script from "./IconSchematic.vue?vue&type=script&lang=ts"
export * from "./IconSchematic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__